import { Stack } from '@mui/material';
import { useAtom } from 'jotai';
import { capitalize } from 'lodash';

import KeyValue from '@/components/KeyValue';
import LargeCard from '@/components/LargeCard';
import VMPGenericChip from '@/components/VMPGenericChip';
import selectedVulnerabilityAtom from '@/pages/VulnerabilityManagement/VMPVulnerabilities/VMPVulnerabilities.store';

const VulnerabilityDetailsInfo = () => {
  const [
    {
      cvss,
      vmp_exposure_index,
      exploited,
      known_ransomware_campaign_use,
      cve,
      category,
      shield_type,
      cvss_level,
      severity
    }
  ] = useAtom(selectedVulnerabilityAtom);

  const details = [
    {
      label: 'CVSS Severity',
      value: (
        <VMPGenericChip
          value={cvss_level || 'N/A'}
          text={`${cvss} ${capitalize(cvss_level || 'N/A')}`}
        />
      )
    },
    {
      label: 'Pondurance Score',
      value: (
        <VMPGenericChip
          type="outlined"
          value={severity}
          text={`${vmp_exposure_index} ${capitalize(severity || 'N/A')}`}
        />
      )
    },
    {
      label: 'Scanner Type',
      value: shield_type ?? 'N/A'
    },
    { label: 'Category', value: category ?? 'N/A' },
    { label: 'CVEs', value: cve ?? 'N/A' },
    { label: 'CISA Known Exploited', value: exploited ? 'Yes' : 'No' },
    {
      label: 'Ransomware Campaign Use',
      value: known_ransomware_campaign_use ? 'Yes' : 'No'
    }
  ];

  return (
    <LargeCard title="Vulnerability Details">
      <Stack spacing={1.5} direction="column">
        <KeyValue items={details} />
      </Stack>
    </LargeCard>
  );
};

export default VulnerabilityDetailsInfo;
